module.exports = __webpack_public_path__ + "img/payments.a48c9e09.svg";